import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

// React Bootstrap
import { Tab, Tabs, Button, Table, Modal, Form, Row, Col, Spinner } from 'react-bootstrap';

// Material UI Icons
import { MdOutlineBorderColor, MdOutlineContentCopy } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";

// Components
import BreadCrumbComponent from '../../../components/BreadCrumbComponent';
import CustomButton from '../../../components/CustomButton';
import AnimationLoading from '../../../components/Animationloading';
import EmptyComponent from '../../../components/EmptyComponent';
import PaginationHelper from '../../../components/PaginationHelper';
import ModalAddReward from './ModalAddReward';
import ModalEditReward from './ModalEditReward';
import LoadingSpinner from '../../../components/LoadingSpinner';


// Constants
import { COLOR_WHITE, LINEAR_GRADIENT_BG, SHOP_SETTING_KEY } from '../../../const';

// Helper functions
import { errorSwal, successSwal, successDeleteSwal } from '../../../helper/sweetalert';
import { ReactIcons } from '../../../icons';
import { useLazyQuery, useMutation } from '@apollo/client';
import { GET_USER_TYPE } from '../../../apollo/userType/mutation';
import { v4 as uuidv4 } from 'uuid';

// import { GET_REWARDS } from '../../../apollo/reward/Query';

import { GET_REWARDS_V2 } from '../../../apollo/reward/Query';
import { UPDATE_SETTINGV2 } from '../../../apollo/setting_apollo/mutation';
import { DELETE_REWARD } from '../../../apollo/reward/Mutation';

// Loyalty Program hook
import useLoyaltyProgram from './LoyaltyProgram';
import { FormatNumber, numberFormat } from '../../../helper';
import PaginationsV2 from '../../../components/PaginationsV2';
const Reward = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('rewards');
  const [loading, setLoading] = useState(false);
  const [deferRewardsTable, setDeferRewardsTable] = useState(false);
  const [now, setNow] = useState(moment());
  // Points settings modal state
  const [showPointsSettingsModal, setShowPointsSettingsModal] = useState(false);
  const [pointsSettings, setPointsSettings] = useState({ amountPerPoint: 10000, pointsPerAmount: 1 });
  const [settingId, setSettingId] = useState(null);
  
  // Image upload state
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  
  // User Type data
  const [getUserTypeData, { data: userTypeData, loading: getUserTypeLoading }] = useLazyQuery(GET_USER_TYPE, { fetchPolicy: 'cache-and-network' });
  const [getRewardData, { data: rewardData, loading: rewardLoading, refetch: refetchRewards }] = useLazyQuery(GET_REWARDS_V2, { fetchPolicy: 'cache-and-network' });
  
  // Mutation
  const [updateSetting] = useMutation(UPDATE_SETTINGV2);
  const [deleteReward] = useMutation(DELETE_REWARD);
  
  // Fetch only user type on mount; rewards and loyalty will be fetched per-tab
  useEffect(() => {
    getUserTypeData();
    
    // Load shop setting from localStorage
    const shopSetting = localStorage.getItem(SHOP_SETTING_KEY);
    if (shopSetting) {
      const setting = JSON.parse(shopSetting);
      if (setting.id) {
        setSettingId(setting.id);
        
        // แสดงค่า pointRate จาก localStorage
        if (setting.pointRate) {
          setPointsSettings({
            amountPerPoint: setting.pointRate,
            pointsPerAmount: 1
          });
        }
      }
    }
  }, []);

  // Rewards state
  const [rewards, setRewards] = useState([]);
  const [showAddRewardModal, setShowAddRewardModal] = useState(false);
  const [showEditRewardModal, setShowEditRewardModal] = useState(false);
  const [editingReward, setEditingReward] = useState(null);

  
  // Rewards pagination state
  const [rewardPage, setRewardPage] = useState(0); // zero-indexed
  const rewardRowsPerPage = 10;
  
  // Filter out deleted rewards
  const activeRewards = useMemo(() => {
    const list = (rewardData?.getRewardsV2?.data ?? []).filter(reward => !reward.isDeleted);
    // Sort so USABLE rewards appear on top
    list.sort((a, b) => {
      const aUsable = a?.status === 'USABLE' ? 1 : 0;
      const bUsable = b?.status === 'USABLE' ? 1 : 0;
      return bUsable - aUsable;
    });
    return list;
  }, [rewardData]);
  
  const totalRewards = activeRewards.length;
  const rewardPageAll = Math.ceil(totalRewards / rewardRowsPerPage) || 1;
  const rewardSliceStart = rewardPage * rewardRowsPerPage;
  const rewardSliceEnd = rewardSliceStart + rewardRowsPerPage;
  const currentRewards = useMemo(() => (
    activeRewards.slice(rewardSliceStart, rewardSliceEnd)
  ), [activeRewards, rewardSliceStart, rewardSliceEnd]);
  
  // Loyalty Program hook
  const {
    filteredCustomers,
    loyaltyData,
    refresh,
  } = useLoyaltyProgram();

  // Trigger API calls based on active tab
  useEffect(() => {
    if (activeTab === 'rewards') {
      getRewardData();
    } else if (activeTab === 'customer-points') {
      refresh();
    }
  }, [activeTab]);

  // Defer heavy table paint until after first paint / idle
  useEffect(() => {
    if (activeTab === 'rewards') {
      const enable = () => setDeferRewardsTable(true);
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(enable, { timeout: 500 });
      } else {
        setTimeout(enable, 0);
      }
    } else {
      setDeferRewardsTable(false);
    }
  }, [activeTab]);
  
  useEffect(() => {
    const t = setInterval(() => setNow(moment()), 1000);
    return () => clearInterval(t);
  }, []);
  
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const goBack = () => {
    history.goBack();
  };

  // Reward functions
  const handleAddReward = () => {
    setEditingReward(null);
    setShowAddRewardModal(true);
  };

  const handleEditReward = (reward) => {
    setEditingReward(reward);
    setShowEditRewardModal(true);
  };

  const handleDeleteReward = async(id) => {
    try {
      setLoading(true);
      await deleteReward({
        variables: {
          where: { id }
        }
      });
      
      // Refetch rewards data after successful deletion
      if (refetchRewards) {
        await refetchRewards();
      } else {
        await getRewardData();
      }
      console.log("Delete reward success");
      
      successSwal('ລຶບລາງວັນສຳເລັດແລ້ວ');
    } catch (error) {
      console.error('Error deleting reward:', error);
      errorSwal('ເກີດຂໍ້ຜິດພາດໃນການລຶບລາງວັນ');
    } finally {
      setLoading(false);
    }
  };


  const handleUpload = async (event) => {
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveReward = (values) => {
    const rewardData = {
      ...values,
      image: fileName || editingReward?.image || ''
    };
    
    if (editingReward) {
      // Update existing reward
      setRewards(rewards.map(reward => 
        reward.id === editingReward.id 
          ? { ...reward, ...rewardData }
          : reward
      ));
      successSwal('ແກ້ໄຂລາງວັນສຳເລັດແລ້ວ!');
    } else {
      // Add new reward
      const newReward = {
        id: Date.now(),
        ...rewardData,
        status: 'USABLE'
      };
      setRewards([...rewards, newReward]);
      successSwal('ເພີ່ມລາງວັນສຳເລັດແລ້ວ!');
    }
    setShowAddRewardModal(false);
    setFile(null);
    setFileName('');
  };

  const handleSavePointsSettings = async (e) => {
    e.preventDefault();
    
    if (!settingId) {
      errorSwal('ບໍ່ພົບຂໍ້ມູນການຕັ້ງຄ່າ');
      return;
    }

    try {
      setLoading(true);
      
      await updateSetting({
        variables: {
          where: { id: settingId },
          data: { 
            pointRate: pointsSettings.amountPerPoint,
          }
        }
      });

      // Update localStorage
      const shopSetting = localStorage.getItem(SHOP_SETTING_KEY);
      if (shopSetting) {
        const setting = JSON.parse(shopSetting);
        setting.pointRate = pointsSettings.amountPerPoint;
        localStorage.setItem(SHOP_SETTING_KEY, JSON.stringify(setting));
      }

      setShowPointsSettingsModal(false);
      successSwal('ບັນທຶກຕັ້ງຄ່າສຳເລັດ');
    } catch (error) {
      console.error('Error updating points settings:', error);
      errorSwal('ເກີດຂໍ້ຜິດພາດໃນການບັນທຶກ');
    } finally {
      setLoading(false);
    }
  };

  // Pagination for customers
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentCustomers = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  
  
  return (
    <div style={{ padding: '20px', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <BreadCrumbComponent
        txtFirst="ຕັ້ງຄ່າ"
          txtSecond="ຈັດການລາງວັນ"
        goback={goBack}
      />

      <div style={{ backgroundColor: COLOR_WHITE, borderRadius: '10px', padding: '20px' }}>
        <div style={{ position: 'relative' }}>
        <Tabs
          mountOnEnter
          unmountOnExit
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
          style={{ borderBottom: '2px solid #dee2e6' }}
        >
          {/* Tab 1: ລາງວັນ */}
          <Tab eventKey="rewards" title="ລາງວັນ">
            <div style={{ marginTop: '20px' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '20px' 
              }}>
                <h4>ລາຍການລາງວັນ</h4>
                <CustomButton
                    onClick={handleAddReward}
                    title="ເພີ່ມລາງວັນ"
                    icon={<ReactIcons.MdAdd />}
                    width="130px"
                    borderRadius="8px" 
                />
              </div>

              {rewardLoading ? (
                <LoadingSpinner />
              ) : (
                deferRewardsTable ? (
                  <div className="custom-table-scrollbar">
                    <Table striped bordered hover responsive style={{ minWidth: '1600px' }}>
                      <thead style={{ background: LINEAR_GRADIENT_BG, color: '#FFFFFF' }}>
                        <tr>
                          <th>ລຳດັບ</th>
                          <th>ລະຫັດ</th>
                          <th>ຊື່ລາງວັນ</th>
                          <th>ປະເພດລາງວັນ</th>
                          <th>ປະເພດລູກຄ້າ</th>
                          <th>ຄະແນນທີ່ໃຊ້</th>
                          <th>ລາງວັນທີ່ຍັງເຫຼືອ</th>
                          <th>ຫຼຸດສູງສຸດ</th>
                          <th>ຍອດຊື້ຂັ້ນຕ່ຳ</th>
                          <th>ຈຳນວນຊື້ຂັ້ນຕ່ຳ</th>
                          <th>ແຖມ</th>
                          <th>ລາຍລະອຽດ</th>
                          <th>ວັນໝົດອາຍຸ</th>
                          <th>ສະຖານະ</th>
                          <th>ຈັດການ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRewards?.map((reward, index) => (
                          <tr key={reward?.id ?? index}>
                            <td>{rewardSliceStart + index + 1}</td>
                            <td>
                              {reward?.code || '-'}
                              {reward?.code && (
                                <MdOutlineContentCopy 
                                  size={16}
                                  style={{ cursor: 'pointer', marginLeft: '8px', color: '#1F3A60', verticalAlign: 'middle' }} 
                                  onClick={() => {
                                    navigator.clipboard.writeText(reward?.code);
                                    successSwal('ຄັດລອກລະຫັດແລ້ວ');
                                  }}
                                  title="คัดลอกรหัส"
                                />
                              )}
                            </td>
                            <td>{reward?.name}</td>
                            <td>{reward?.rewardType === 'DISCOUNT' ? 'ສ່ວນຫຼຸດ' : reward?.rewardType === 'FREE_SHIPPING' ? 'ສົ່ງຟຣີ' : 'ສິນຄ້າ'}</td>
                            <td>{reward?.userType?.name||"ທຸກຄົນ"}</td>
                            <td>{reward?.pointMin} ຄະແນນ</td>
                            <td>{reward?.remainUser}</td>
                            <td>{FormatNumber(reward?.maxDiscountAmount || "-")}</td>
                            <td>{FormatNumber(reward?.minimumOrderAmount || "-")}</td>
                            <td>{reward?.minimumOrderQuantity || 0}</td>
                            <td>{reward?.freeItemQuantity || 0}</td>
                            <td>{reward?.description=== "" ? 'ບໍ່ໄດ້ລະບຸ...' : reward?.description}</td>
                            
                            <td>
                              {(() => {
                                const end = moment(reward?.endDate);
                                const remainingMs = end.diff(now);
                                const remainingDays = Math.ceil(remainingMs / (1000 * 60 * 60 * 24));
                                const remainingHours = Math.ceil(remainingMs / (1000 * 60 * 60));
                                
                                // Expired
                                if (remainingMs <= 0) {
                                  return (
                                    <span style={{ color: 'gray' }}>
                                      {end.format('DD/MM/YYYY HH:mm')} (0 ວັນ)
                                    </span>
                                  );
                                }
                                
                                // Countdown only when <= 1 hour remaining
                                if (remainingMs <= 60 * 60 * 1000) {
                                  const hours = Math.floor(remainingMs / (1000 * 60 * 60));
                                  const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
                                  const seconds = Math.floor((remainingMs % (1000 * 60)) / 1000);
                                  return (
                                    <span>
                                      {end.format('DD/MM/YYYY HH:mm')}
                                      <br />
                                      <span style={{ color: 'red' }}>
                                        {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                                      </span>
                                    </span>
                                  );
                                }
                                
                                // Between 1 hour and 1 day: show hours remaining (static)
                                if (remainingMs < 24 * 60 * 60 * 1000) {
                                  return (
                                    <>
                                      {end.format('DD/MM/YYYY HH:mm')}
                                      <span style={{ color: 'red' }}> ({remainingHours} ຊົ່ວໂມງ)</span>
                                    </>
                                  );
                                }
                                
                                // More than 1 day remaining
                                return (
                                  <>
                                    {end.format('DD/MM/YYYY HH:mm')}
                                    <span style={{ color: 'red' }}> ({remainingDays} ວັນ)</span>
                                  </>
                                );
                              })()}
                            </td>
                            <td>
                              <span className={`badge ${
                                reward?.status === 'USABLE' ? 'bg-success' : 
                                reward?.status === 'EXPIRED' ? 'bg-warning' : 
                                reward?.status === "OUT_OF_STOCK" ? 'bg-danger' : 
                                'bg-secondary'
                              }`}>
                                {reward?.status === 'USABLE' ? 'ໃຊ້ງານໄດ້' : 
                                 reward?.status === 'EXPIRED' ? 'ໝົດອາຍຸ' : 
                                 reward?.status === "OUT_OF_STOCK" ? 'ເຄື່ອງໝົດ' : 
                                 'ປິດໃຊ້ງານ'
                              }
                              </span>
                            </td>
                            <td>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEditReward(reward)}
                                style={{ marginRight: '5px' }}
                              >
                                <MdOutlineBorderColor />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleDeleteReward(reward.id)}
                              >
                                <RiDeleteBin6Line />
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                ) : (
                  <LoadingSpinner />
                )
              )}
              {deferRewardsTable && totalRewards > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="d-flex align-items-center" style={{ opacity: 0.8 }}>
                    <span>
                      ສະແດງ {Math.min(totalRewards, rewardSliceStart + 1)}-{Math.min(totalRewards, rewardSliceEnd)} ຈາກ {totalRewards}
                    </span>
                  </div>
                  <PaginationsV2
                    count={totalRewards}
                    page={rewardPage}
                    rowsPerPage={rewardRowsPerPage}
                    pageAll={rewardPageAll}
                    onPageChange={setRewardPage}
                  />
                </div>
              )}

              {currentRewards?.length === 0 && (
                <EmptyComponent />
              )}
            </div>
          </Tab>

          {/* Tab 3: ຄະແນນຂອງລູກຄ້າ */}
          <Tab eventKey="customer-points" title="ຄະແນນຂອງອໍເດີ">
            <div style={{ marginTop: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h4>ຄະແນນຂອງອໍເດີ</h4>
                {/* <InputGroup style={{ width: '300px' }}>
                  <Form.Control
                    type="text"
                    placeholder="ຄົ້ນຫາຊື່ ຫຼື ເບີໂທ..."
                    value={searchCustomer}
                    onChange={(e) => setSearchCustomer(e.target.value)}
                  />
                  <InputGroup.Text>
                    <SearchIcon />
                  </InputGroup.Text>
                </InputGroup> */}
              </div>

              <div className="custom-table-scrollbar">
                <Table striped bordered hover responsive>
                  <thead  style={{ background: LINEAR_GRADIENT_BG, color: '#FFFFFF' }}>
                    <tr>
                      <th>ລຳດັບ</th>
                      <th>ຊື່ລູກຄ້າ</th>
                      <th>ເພດ</th>
                      <th>ເບີໂທ</th>
                      <th>ຄະແນນສະສົມ</th>
                      <th>ຍອດຊື້ລວມ (ກີບ)</th>
                      <th>ເລດຄະແນນ</th>
                      <th>ລະຫັດອໍເດີ</th>
                      <th>ສະຖານະ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loyaltyData?.loyaltyPrograms?.data?.length > 0 ? (
                      loyaltyData?.loyaltyPrograms?.data.map((data, index) => (
                        <tr key={data.id}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>{(data?.userConfirm?.name && data?.userConfirm?.name.trim())
                            ? data?.userConfirm?.name + " " + data?.userConfirm?.lastname
                            : <span className="text-danger">ບໍ່ລະບຸຊື່</span>
                            }</td>
                          <td>{data?.userConfirm?.gender === 'MALE' ? 'ຊາຍ' : 'ຍິງ'}</td>
                          <td>{data?.userConfirm?.phone}</td>
                          <td>
                            <span className="badge bg-primary" style={{ fontSize: '14px' }}>
                              {data?.point} ຄະແນນ
                            </span>
                          </td>
                          <td>{numberFormat(data?.money)}</td>
                          <td>{numberFormat(data?.pointRate)} / 1 ຄະແນນ</td>
                          <td>{data?.orderGroup?.code}</td>
                          <td>
                            <span className={`badge ${
                              data.status ?  'bg-success'  : 'bg-warning'
                            }`}>
                              {data.status ? 'ອັບເດດ' : 'ຍັງບໍ່ອັບເດດ'}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center">ບໍ່ພົບຂໍ້ມູນອໍເດີ</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>


              {loyaltyData?.loyaltyPrograms?.total === 0 && (
                <div className="text-center mt-3">
                  <EmptyComponent />
                </div>
              )}

      {totalPages > 1 && (
        <PaginationHelper
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
          </Tab>
        </Tabs>
        {/* ปุ่มโมดอลอยู่บรรทัดเดียวกับปุ่มแท็บ (ชิดขวา) */}
        <div style={{ position: 'absolute', right: 0, top: 0 }}>
             <CustomButton 
                icon={<ReactIcons.MdAdd />}
                width="200px"
                borderRadius="8px" 
                title="ຕັ້ງຄ່າການຄຳນວນຄະແນນ"
                onClick={() => {
                  // โหลดค่า pointRate จาก localStorage ทุกครั้งที่เปิดโมดอล
                  const shopSetting = localStorage.getItem(SHOP_SETTING_KEY);
                  if (shopSetting) {
                    const setting = JSON.parse(shopSetting);
                    if (setting.pointRate) {
                      setPointsSettings({
                        amountPerPoint: setting.pointRate,
                        pointsPerAmount: 1
                      });
                    }
                  }
                  setShowPointsSettingsModal(true);
                }}
              />
        </div>
        </div>
      </div>

      {/* Modal for Add/Edit Reward */}
      <ModalAddReward
          show={showAddRewardModal}
          onClose={() => setShowAddRewardModal(false)}
          editingReward={null}
          onSubmit={handleSaveReward}
          file={file}
          onUpload={handleUpload}
          userTypeLoading={getUserTypeLoading}
          userTypeData={userTypeData}
      />
      {editingReward && (
        <ModalEditReward
          show={showEditRewardModal}
          onClose={() => { setShowEditRewardModal(false); setEditingReward(null); }}
          editingReward={editingReward}
          file={file}
          onUpload={handleUpload}
          userTypeLoading={getUserTypeLoading}
          userTypeData={userTypeData}
        />
      )}
      {/* Modal: Points Settings */}
      <Modal show={showPointsSettingsModal} onHide={() => setShowPointsSettingsModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>ຕັ້ງຄ່າການຄຳນວນຄະແນນ</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSavePointsSettings}>
          <Modal.Body>
            <Row>
              <Col md={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>ຈຳນວນເງິນ (ກີບ)</Form.Label>
                  <Form.Control
                    type="number"
                    value={pointsSettings.amountPerPoint}
                    onChange={(e) => setPointsSettings(ps => ({ ...ps, amountPerPoint: Number(e.target.value) }))}
                    placeholder="ກະລຸນາໃສ່ຈຳນວນເງິນ"
                  />
                  <Form.Text className="text-muted">ຈຳນວນເງິນທີ່ໃຊ້ໃນການແລກຄະແນນ</Form.Text>
                </Form.Group>
              </Col>
              <Col md={6} xs={12}>
                <Form.Group className="mb-3">
                  <Form.Label>ຄະແນນທີ່ໄດ້ຮັບ</Form.Label>
                  <Form.Control
                    type="number"
                    value={pointsSettings.pointsPerAmount}
                    disabled={true}
                    onChange={(e) => setPointsSettings(ps => ({ ...ps, pointsPerAmount: Number(e.target.value) }))}
                    placeholder="ກະລຸນາໃສ່ຈຳນວນຄະແນນ"
                  />
                  <Form.Text className="text-muted">ຈຳນວນຄະແນນທີ່ລູກຄ້າຈະໄດ້ຮັບ</Form.Text>
                </Form.Group>
              </Col>
            </Row>
            <div style={{ backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '8px' }}>
              <div style={{ fontWeight: 600, marginBottom: '6px' }}>ຕົວຢ່າງການຄຳນວນ:</div>
              <div>
                ລູກຄ້າຊື້ສິນຄ້າ {pointsSettings.amountPerPoint} ກີບ ຈະໄດ້ຮັບ {pointsSettings.pointsPerAmount} ຄະແນນ
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowPointsSettingsModal(false)}>ປິດ</Button>
            <Button type="submit" variant="primary">{ loading ? <Spinner size="sm" /> : 'ບັນທຶກ'}</Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {loading && <AnimationLoading />}
    </div>
  );
};

export default Reward;
